import React from 'react';
import ReactDOM from 'react-dom';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { estados } from '../../util/estados';
import './EmpresaForm.css';

class EmpresaForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            owner: '',
            owner_email: '',
            cnpj: '',
            cellphone: '',
            status: 1,
            default_role_ids: [],
            roles_options: [],
            city_ids: [],
            selected_states: [],
            cities_options: [],
            errors: {},
            loading: false,
        };
        this.handleSubmit       = this.handleSubmit.bind(this);
        this.handleStatesChange = this.handleStatesChange.bind(this);
        this.handleCellphoneChange = this.handleCellphoneChange.bind(this);
    }

    handleCellphoneChange(e) {
        const digits = e.target.value.replace(/\D/g, '').slice(0, 11);
        let masked = digits;

        if (digits.length > 10) {
            masked = digits.replace(/^(\d{2})(\d{5})(\d{0,4}).*/, '($1) $2-$3');
        } else if (digits.length > 6) {
            masked = digits.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3');
        } else if (digits.length > 2) {
            masked = digits.replace(/^(\d{2})(\d+)/, '($1) $2');
        } else if (digits.length > 0) {
            masked = digits.replace(/^(\d+)/, '($1');
        }

        this.setState({ cellphone: masked });
    }

    // Retorna os UFs únicos das cidades selecionadas com base em cities_options
    deriveStatesFromCities(cityIds, citiesOptions) {
        const map = {};
        citiesOptions.forEach(group => {
            group.items.forEach(city => { map[city.value] = group.label; });
        });
        return [...new Set((cityIds || []).map(id => map[id]).filter(Boolean))];
    }

    componentDidMount() {

        const isEdit = route().current() === 'empresa.edit';

        const citiesPromise = axios.get('/cidades/for-select').then(r => r.data);

        axios.get('/role-json').then(r => {
            this.setState({ roles_options: r.data.roles });
        });

        const empresaId = route().params?.empresa;

        if (isEdit && empresaId) {
            this.setState({ loading: true });

            Promise.all([citiesPromise, axios.get(`/empresas-crud/${empresaId}`)])
                .then(([citiesOptions, companyRes]) => {
                    const { name, owner, owner_email, cnpj, cellphone, city_ids, default_role_ids, status } = companyRes.data;
                    this.setState({
                        cities_options:   citiesOptions,
                        name:             name || '',
                        owner:            owner || '',
                        owner_email:      owner_email || '',
                        cnpj:             cnpj || '',
                        cellphone:        cellphone || '',
                        status:           status !== undefined ? status : 1,
                        default_role_ids: default_role_ids || [],
                        city_ids:         city_ids || [],
                        selected_states:  this.deriveStatesFromCities(city_ids, citiesOptions),
                        loading:          false,
                    });
                })
                .catch(() => this.setState({ loading: false }));
        } else {
            citiesPromise.then(citiesOptions => this.setState({ cities_options: citiesOptions }));
        }
    }

    handleStatesChange(e) {
        const newStates = e.value;
        const { cities_options, city_ids } = this.state;

        const validIds = new Set();
        cities_options
            .filter(g => newStates.includes(g.label))
            .forEach(g => g.items.forEach(c => validIds.add(c.value)));

        this.setState({
            selected_states: newStates,
            city_ids: city_ids.filter(id => validIds.has(id)),
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        const { name, owner, owner_email, cnpj, cellphone, status, default_role_ids, city_ids } = this.state;
        const isEdit = route().current() === 'empresa.edit';
        const empresaId = route().params?.empresa;

        const url    = isEdit ? `/empresas-crud/${empresaId}` : '/empresas-crud';
        const method = isEdit ? 'put' : 'post';

        this.setState({ loading: true, errors: {} });

        axios[method](url, { name, owner, owner_email, cnpj, cellphone, status, default_role_ids, city_ids })
            .then(response => {
                window.location.href = response.data.redirect;
            })
            .catch(error => {
                if (error.response && error.response.status === 422) {
                    this.setState({ errors: error.response.data.errors, loading: false });
                } else {
                    this.setState({ loading: false });
                }
            });
    }

    render() {
        const {
            name, owner, owner_email, cnpj, cellphone,
            status, default_role_ids, roles_options,
            city_ids, selected_states, cities_options,
            errors, loading,
        } = this.state;

        const STATUS_OPTIONS = [
            { label: 'Ativa',                           value: 1 },
            { label: 'Suspensa',                        value: 0 },
            { label: 'Suspensa por Falta de Pagamento', value: 2 },
        ];

        const isEdit = window.__EMPRESA_ACTION__ === 'edit';
        const submitLabel = isEdit ? 'Atualizar Empresa' : 'Criar Empresa';

        if (loading && isEdit && !name) {
            return (
                <div className="empresa-form">
                    <div className="ef-loading">
                        <i className="fa fa-spinner fa-spin"></i> Carregando...
                    </div>
                </div>
            );
        }

        const filtered_cities = selected_states.length
            ? cities_options
                .filter(g => selected_states.includes(g.label))
                .flatMap(g => g.items)
            : [];

        return (
            <form className="empresa-form" onSubmit={this.handleSubmit}>
                <fieldset>
                    <div className="form-group row">
                        <div className="col-12">
                            <label className={`ef-label${errors.name ? ' ef-label--error' : ''}`}>Nome*</label>
                            <InputText
                                className={`d-block w-100 input-disabled${errors.name ? ' ef-invalid' : ''}`}
                                name="name"
                                value={name}
                                onChange={e => this.setState({ name: e.target.value })}
                                placeholder="Nome"
                            />
                            {errors.name && <div className="ef-error">{errors.name[0]}</div>}
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <div className="form-group row">
                        <div className="col-6">
                            <label className={`ef-label${errors.owner ? ' ef-label--error' : ''}`}>Responsável*</label>
                            <InputText
                                className={`d-block w-100 input-disabled${errors.owner ? ' ef-invalid' : ''}`}
                                name="owner"
                                value={owner}
                                onChange={e => this.setState({ owner: e.target.value })}
                                placeholder="Responsável"
                            />
                            {errors.owner && <div className="ef-error">{errors.owner[0]}</div>}
                        </div>
                        <div className="col-6">
                            <label className={`ef-label${errors.owner_email ? ' ef-label--error' : ''}`}>Email responsável*</label>
                            <InputText
                                className={`d-block w-100 input-disabled${errors.owner_email ? ' ef-invalid' : ''}`}
                                name="owner_email"
                                value={owner_email}
                                onChange={e => this.setState({ owner_email: e.target.value })}
                                placeholder="Email responsável"
                            />
                            {errors.owner_email && <div className="ef-error">{errors.owner_email[0]}</div>}
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <div className="form-group row">
                        <div className="col-6">
                            <label className="ef-label">CNPJ</label>
                            <InputMask
                                className="d-block w-100 input-disabled"
                                name="cnpj"
                                value={cnpj}
                                onChange={e => this.setState({ cnpj: e.value })}
                                mask="99.999.999/9999-99"
                                placeholder="CNPJ"
                            />
                            {errors.cnpj && <div className="ef-error">{errors.cnpj[0]}</div>}
                        </div>
                        <div className="col-6">
                            <label className="ef-label">Contato</label>
                            <input
                                className="d-block w-100 p-inputtext input-disabled"
                                name="cellphone"
                                value={cellphone}
                                onChange={this.handleCellphoneChange}
                                placeholder="(00) 0000-0000 ou (00) 00000-0000"
                                maxLength={16}
                            />
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <div className="form-group">
                        <label className="ef-label">Perfil padrão dos usuários</label>
                        <MultiSelect
                            value={default_role_ids}
                            options={roles_options}
                            optionLabel="label"
                            optionValue="value"
                            onChange={e => this.setState({ default_role_ids: e.value })}
                            placeholder="Selecione os perfis padrão"
                            filter
                            filterPlaceholder="Buscar perfil..."
                            display="chip"
                            className="w-100"
                        />
                    </div>
                </fieldset>

                {isEdit && (
                    <fieldset>
                        <div className="form-group">
                            <label className="ef-label">Status da Empresa</label>
                            <Dropdown
                                value={status}
                                options={STATUS_OPTIONS}
                                optionLabel="label"
                                optionValue="value"
                                onChange={e => this.setState({ status: e.value })}
                                className="w-100"
                            />
                        </div>
                    </fieldset>
                )}

                <fieldset>
                    <div className="form-group row">
                        <div className="col-6">
                            <label className="ef-label">Estados</label>
                            <MultiSelect
                                value={selected_states}
                                options={estados}
                                optionLabel="label"
                                optionValue="value"
                                onChange={this.handleStatesChange}
                                placeholder="Selecione os estados"
                                filter
                                filterPlaceholder="Buscar estado..."
                                display="chip"
                                className="w-100"
                            />
                        </div>
                        <div className="col-6">
                            <label className="ef-label">Cidades</label>
                            <MultiSelect
                                value={city_ids}
                                options={filtered_cities}
                                optionLabel="label"
                                optionValue="value"
                                onChange={e => this.setState({ city_ids: e.value })}
                                placeholder={selected_states.length ? 'Selecione as cidades' : 'Selecione um estado primeiro'}
                                disabled={!selected_states.length}
                                filter
                                filterPlaceholder="Buscar cidade..."
                                display="chip"
                                className="w-100"
                            />
                        </div>
                    </div>
                </fieldset>

                <fieldset>
                    <div className="form-group">
                        <button
                            type="submit"
                            className="btn btn-primary ef-submit-btn"
                            disabled={loading}
                        >
                            {loading ? <><i className="fa fa-spinner fa-spin"></i> Aguarde...</> : submitLabel}
                        </button>
                    </div>
                </fieldset>
            </form>
        );
    }
}

const mountPoint = document.getElementById('js-empresa-form');
if (mountPoint) {
    ReactDOM.render(<EmpresaForm />, mountPoint);
}
